// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.input_calendar.mid[data-v-25cbcf48], .input_calendar.mid input[data-v-25cbcf48] {\n    width: 200px;\n}\ndiv.input_error .inp_cal[data-v-25cbcf48] {\n  border: 1px solid #f2084f !important;\n}\n.impp[data-v-25cbcf48] {\n  position: absolute;\n}\n.imp[data-v-25cbcf48] {\n  position: relative;\n  top: 0px;\n  left: -220px;\n  z-index: 99999;\n}\n", ""]);
// Exports
module.exports = exports;
